import { setElementInert, setParentInert } from '../../util/a11y/handle-inert';
import { breakpoint } from '../../util/helpers';
import strings from '../../lang/strings.json';
import _browseGrid from '../modules/browse-grid'

export default {
  init() {
    // first location breaker only
    const $module = document.querySelector('.ms-hero-filter');

    this.filterIds = [];
    this.currentLang = document.querySelector('html').lang;

    if ($module) {
      this.startListener($module)
    }
  },
  startListener($module) {
    const html = document.querySelector('html');
    const body = document.body;
    const main = body.querySelector('main');
    const wrap = body.querySelector('.wrap');
    const parentBrowsePage = document.querySelector('.ms-browse-grid');
    const mainNavigation = document.querySelector('.ms-navigation');
    const modalTriggerButton = document.getElementById('filter-modal-button');
    const modalElement = $module.querySelector('.ms-hero-filter__modal');
    const modalCloseButton = document.getElementById('filter-close-button');
    const modalDropdowButtons = $module.querySelectorAll('.ms-hero-filter__modal-dropdown-toggle');
    const modalDropdowOptions = $module.querySelectorAll('.ms-hero-filter__modal-dropdown-option');
    const filterButtonWrapper = $module.querySelector('.ms-hero-filter__button-wrapper');
    const filterButtons = $module.querySelectorAll('.ms-hero-filter__filter-button');
    const filterClearButtons = $module.querySelectorAll('.ms-hero-filter__filter-clear');
    const filterApplyButton = $module.querySelector('.ms-hero-filter__filter-apply');
    const dropdownFilterSelect = $module.querySelectorAll('.ms-hero-filter__dropdown');

    const parents = [body, main];
    const exceptions = [wrap, parentBrowsePage];

    const toggleModal = () => {
      const isSafariMobile = navigator.userAgent.match(/iphone|ipod|ipad/i);

      if (modalElement.classList.contains('active')) {
        modalElement.classList.remove('active');

        html.classList.remove('safari-nav-open');
        html.classList.remove('modal-on');

        mainNavigation.classList.add('ms-navigation--docked');

        setParentInert(false, parents, exceptions);
        setElementInert(false, mainNavigation);
        setElementInert(false, modalTriggerButton);
        setElementInert(false, filterButtonWrapper);

        // Set the focus back to modal open button.
        setTimeout(() => {
          modalTriggerButton.focus();
        }, 100);
      } else {
        mainNavigation.classList.remove('ms-navigation--docked');

        if (isSafariMobile) {
          // Keep the scrolling position but 1px lower
          window.scrollTo(0, modalTriggerButton.getBoundingClientRect().top + 1);
          // force the nav bar to show
          html.classList.add('safari-nav-open');
        }

        html.classList.add('modal-on');

        modalElement.classList.add('active');

        setParentInert(true, parents, exceptions);
        setElementInert(true, mainNavigation);
        setElementInert(true, modalTriggerButton);
        setElementInert(true, filterButtonWrapper);

        // Set the focus to modal close button.
        setTimeout(() => {
          modalCloseButton.focus();
          // assign scrolling behavior
          if (isSafariMobile) {
            modalElement.classList.add('--allow-scroll');
          }
        }, 100);
      }
    };

    const setSelectedIds = (isModalDropdown = false) => {
      const currentIds = [];

      if (isModalDropdown) {
        modalDropdowOptions.forEach(dropdownOption => {
          if (dropdownOption.classList.contains('selected')) {
            const { filterId, parentIndex } = dropdownOption.dataset;
            const name = dropdownOption.textContent;

            if (filterId) {
              renderButton(filterId, name, parentIndex);
              currentIds.push(filterId);
              appendActiveTag();
            }
          }
        })
      }
      else {
        dropdownFilterSelect.forEach((selectElement, index) => {
          const { value } = selectElement;

          if (value) {
            const name = selectElement.querySelectorAll('option')[selectElement.selectedIndex].textContent;
            renderButton(value, name, index);
            currentIds.push(value);
          }
        });
      }

      if (currentIds.length) {
        // show clear buttons
        filterClearButtons.forEach(btn => {
          btn.classList.remove('hidden');
        });
      }

      this.filterIds = currentIds;

      // Fire ajax call upon storing filter ids.
      filterItems();
    };

    const renderButton = (id, name, index) => {
      const parentContainer = document.querySelector('.ms-hero-filter__button-list');
      const markup = `
        <button
          type="button"
          class="ms-button ms-button--closable-filter ms-hero-filter__filter-button"
          aria-label="${strings[this.currentLang].remove} ${name} tag"
          data-filter-id="${id}"
          data-filter-parent-index="${index}">
          ${name}
          <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <line y1="-1" x2="19.6927" y2="-1" transform="matrix(0.710924 -0.703268 0.710924 0.703268 2 15.6016)" stroke="white" stroke-width="2"></line>
            <line y1="-1" x2="19.6927" y2="-1" transform="matrix(0.710924 0.703268 -0.710924 0.703268 1 1.75391)" stroke="white" stroke-width="2"></line>
          </svg>
        </button>
      `;

      // check if button is already added, do not add it again
      const foundButton = parentContainer.querySelector(`button[data-filter-id="${id}"]`);
      // check if a button from the same parent dropdown is already in, delete it.
      const foundBtnFromSameParent = parentContainer.querySelector(`button[data-filter-parent-index="${index}"]`);

      if (foundBtnFromSameParent && foundBtnFromSameParent !== foundButton) { foundBtnFromSameParent.remove(); }
      if (!foundButton) { parentContainer.innerHTML += markup; }
    };

    const filterItems = () => {
      // Ajax call here.
      // On modal filter, the filters will be applied upon clicking the apply button.
      // On desktop dropdowns, fire the ajax call upon changing of dropdown value.
      // Store the ids in the global filterIds property.
      // The value to be passed should be array of ids

      this.ajaxHandler(1, this.filterIds);

      return null;
    }

    const removeSingleFilter = (singleFilter) => {
      const { dataset } = singleFilter;
      const { filterId, filterParentIndex } = dataset;
      const optionSelected = $module.querySelector(`.ms-hero-filter__dropdown option[value="${filterId}"]`);
      const buttonsContainer = document.querySelector('.ms-hero-filter__button-list');

      const parentButtonSpan = document.querySelector(`.ms-hero-filter__modal-dropdown-toggle[data-parent-filter-id="${filterParentIndex}"] > span`);

      // remove appendedSpan on element on mobile
      if (parentButtonSpan) {
        const appendedSpan = parentButtonSpan.querySelector('span.appended-tag');

        if (appendedSpan) { appendedSpan.remove(); }
      }

      // remove selected item on mobile
      modalDropdowOptions.forEach(option => {
        const optionFilterId = option.dataset.filterId;

        if (optionFilterId === filterId) {
          option.classList.remove('selected');
        }
      });

      if (optionSelected) {
        // Reset the dropdown if the filter is removed.
        optionSelected.parentElement.selectedIndex = 0;
        optionSelected.parentElement.style.color = '#727272';
      }

      // Remove id from the stored list then fire ajax call.
      this.filterIds = this.filterIds.filter(id => id !== filterId);

      filterItems();

      singleFilter.remove();

      // hide clear buttons if there are no more buttons to close
      if (buttonsContainer.childElementCount === 0) {
        filterClearButtons.forEach(btn => {
          btn.classList.add('hidden');
        });
      }
    };

    const clearFilterItems = () => {
      const buttonsContainer = document.querySelector('.ms-hero-filter__button-list');
      const selectedModalOptions = $module.querySelectorAll('.ms-hero-filter__modal-dropdown-option.selected');
      const appendedSpans = document.querySelectorAll('span.appended-tag');

      // remove spans on mobile
      if (appendedSpans.length) {
        appendedSpans.forEach(span => {
          span.remove();
        });
      }

      const heroFilterForm = document.getElementById('hero-filter-form');

      // remove all buttons
      buttonsContainer.innerHTML = '';

      // hide clear buttons
      filterClearButtons.forEach(btn => {
        btn.classList.add('hidden');
      });

      // Remove selected states from modal dropdowns.
      selectedModalOptions.forEach(modalOption => modalOption.classList.remove('selected'));
      // Remove the closable button filters.
      filterButtons.forEach(closableFilter => closableFilter.remove());
      // Reset the filter form
      heroFilterForm.reset();
      // reset all select fields
      dropdownFilterSelect.forEach(select => {
        select.selectedIndex = 0;
        select.style.color = '#727272';
      });

      this.filterIds = [];
      filterItems();
    }

    if (modalTriggerButton) {
      modalTriggerButton.addEventListener('click', () => { toggleModal() });
    }

    if (modalCloseButton) {
      modalCloseButton.addEventListener('click', () => { toggleModal() });
    }

    modalDropdowButtons.forEach(dropdownButton => {
      dropdownButton.addEventListener('click', () => {
        const ariaExpandState = dropdownButton.getAttribute('aria-expanded');
        const lastActiveButton = $module.querySelector('.ms-hero-filter__modal-dropdown-toggle.active');

        if (lastActiveButton && lastActiveButton !== dropdownButton) {
          lastActiveButton.classList.remove('active');
          lastActiveButton.setAttribute('aria-expanded', false);
          lastActiveButton.nextElementSibling.classList.remove('expanded');

          setElementInert(true, lastActiveButton.nextElementSibling);
        }

        dropdownButton.classList.toggle('active');
        dropdownButton.setAttribute('aria-expanded', ariaExpandState === 'false' ? true : false);
        dropdownButton.nextElementSibling.classList.toggle('expanded');

        setElementInert(!dropdownButton.classList.contains('active'), dropdownButton.nextElementSibling);
      });
    });

    modalDropdowOptions.forEach(modalOption => {
      modalOption.addEventListener('click', () => {
        const lastSelectedOption = modalOption.parentElement.querySelector('.selected');

        if (lastSelectedOption && lastSelectedOption !== modalOption) {
          lastSelectedOption.classList.remove('selected');
          lastSelectedOption.setAttribute('aria-selected', false)
        }

        if (!modalOption.classList.contains('selected')) {
          modalOption.classList.add('selected');
          modalOption.setAttribute('aria-selected', true);
        }
      });
    });

    dropdownFilterSelect.forEach((dropdownFilter, key) => {
      dropdownFilter.addEventListener('change', ({ target }) => {
        setSelectedIds();
        grayOut(target);

        // remove button if dropdown's selected index is zero
        if (target.selectedIndex === 0) {
          const targetButton = document.querySelector(`.ms-hero-filter__filter-button[data-filter-parent-index="${key}"]`);
          removeSingleFilter(targetButton);
        }
      });
    });

    if (filterApplyButton) {
      filterApplyButton.addEventListener('click', () => {
        setSelectedIds(true);

        toggleModal();
      });
    }

    filterClearButtons.forEach(clearButton => {
      clearButton.addEventListener('click', () => {
        clearFilterItems();
      });
    });

    // collect all IDS first if this is an alternate variant
    if (parentBrowsePage.dataset.filterType === 'alternate') {
      this.filterIds = parentBrowsePage.dataset.tagIds.split(',');

      // let's check if the url contains parameters
      const url = new URL(window.location.href);
      const searchParams = new URLSearchParams(url.search);

      if (searchParams.get('tags')) {
        // if the parameter is not empty, we search for the active buttons to get their IDs.
        this.filterIds = Array.from(filterButtons).reduce((result, btn) => {
          if (btn.classList.contains('active')) {
            result.push(btn.dataset.filterId);
          }

          return result;
        }, []);
      }
    }

    // Dynamic binding since the buttons are created on the fly
    document.addEventListener('click', ({ target }) => {
      const isClosableFilter = target.classList.contains('ms-button--closable-filter');
      const { filterId } = target.dataset;

      if (!target.classList.contains('ms-hero-filter__filter-button')) { return; }

      if (isClosableFilter) {
        removeSingleFilter(target);
      }
      else {
        // all code below only applies on Press Releases version of the Hero Filter
        target.classList.toggle('active');
        // toggle id inside array
        this.filterIds.includes(filterId) ? this.filterIds = this.filterIds.filter(id => id !== filterId) : this.filterIds.push(filterId);
        // toggle aria-pressed
        target.setAttribute('aria-pressed', target.getAttribute('aria-pressed') === 'true' ? false : true);
        // call ajax function
        this.ajaxHandler(1, this.filterIds, target);
      }
    });

    // handle mobile selected tag per group
    const appendActiveTag = () => {
      modalDropdowOptions.forEach(dd => {
        if (dd.classList.contains('selected')) {
          const { parentIndex } = dd.dataset;
          const parentButtonSpan = document.querySelector(`.ms-hero-filter__modal-dropdown-toggle[data-parent-filter-id="${parentIndex}"] > span`);
          const appendedSpan = parentButtonSpan.querySelector('span.appended-tag');

          if (appendedSpan) { appendedSpan.remove(); }
          parentButtonSpan.innerHTML += `<span class="appended-tag">: ${dd.textContent}</span>`;
        }
      });
    };

    // call the function on load, and call then on demand
    appendActiveTag();

    // grayout the first option
    const grayOut = (single) => {
      if (single) {
        if (single.selectedIndex === 0) {
          single.style.color = '#727272';
        } else {
          single.style.color = '#052d5d';
        }
      } else {
        dropdownFilterSelect.forEach(select => {
          if (select.selectedIndex === 0) {
            select.style.color = '#727272';
          } else {
            select.style.color = '#052d5d';
          }
        })
      }
    };

    // run on load
    if (parentBrowsePage.dataset.filterType === 'browse') {
      // run on load and on demand
      grayOut();
      setSelectedIds(breakpoint() === 'mobile');
    }
  },
  ajaxHandler(page = 1, filterIds) {
    const browseGrid = document.querySelector('.ms-browse-grid');
    const targetContainer = browseGrid.querySelector('.ms-browse-grid__cards-wrapper');
    const totalCounter = browseGrid.querySelector('.ms-browse-grid__results-text > span');
    const noResults = browseGrid.querySelector('.ms-browse-grid__no-results-wrapper');
    const filterType = browseGrid.dataset.filterType;
    const navPagination = browseGrid.querySelector('nav.pagination');
    const ajaxPagination = browseGrid.querySelector('.ms-browse-grid__pagination');

    fetch(window.msAjax.ajax_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded'}),
      body: `action=fetch_browse_grid_data&page=${page}&filter_type=${filterType}&filter_ids=${filterIds}`})
      .then(resp => resp.json())
      .then(({ html, total, pagination, max_num_pages }) => {
        targetContainer.innerHTML = '';
        targetContainer.innerHTML = html;
        navPagination.style.display = 'none';
        _browseGrid.currentPage = 1;
        _browseGrid.maxPages = max_num_pages;
        browseGrid.dataset.tagIds = filterIds.join();

        if ( pagination ) {
          ajaxPagination.innerHTML = pagination;
          navPagination.style.removeProperty('display');
          _browseGrid.startAjaxPagination();
          _browseGrid.redrawPageLinks();
        }

        // SR only. Create this on-the-fly for announcement
        const a11yLive = document.createElement('span');
        a11yLive.setAttribute('aria-live', 'polite');
        a11yLive.classList.add('ms-browse-grid__results-announcement');
        a11yLive.innerHTML = `${total} ${total === 1 ? strings[this.currentLang].matchingResult : strings[this.currentLang].matchingResults}.`;

        // append to the main module
        browseGrid.appendChild(a11yLive);

        // remove it after announcing, estimated 2 seconds
        setTimeout(() => {
          a11yLive.remove();
        }, 2000);

        if (total) {
          totalCounter.innerHTML = '';
          totalCounter.innerHTML = total;
          noResults.style.display = 'none'
          noResults.setAttribute('aria-hidden', 'true');

          // don't show this if it's alternate type
          if (filterType !== 'alternate') {
            totalCounter.parentElement.classList.remove('hidden');
          }
        } else {
          noResults.style.display = 'block';
          noResults.setAttribute('aria-hidden', 'false');
          totalCounter.parentElement.classList.add('hidden');
        }
      });
  },
}



// WEBPACK FOOTER //
// /private/var/www/Morton-Windsor/wp-content/themes/morton-salt/resources/assets/scripts/multisite/modules/hero-filter.js